export const newsList = [
  {
    id: "n1",
    title: "《星际孤旅》发布终极预告：一场关于归途的静默漂流",
    date: "2026年10月14日",
    category: "上映预告",
    summary:
      "影片以极简的太空场景和大量静默镜头构建叙事，终极预告首次公开了“归途号”失联后的关键片段，并确认将于下月登陆院线。",
    content:
      "《星际孤旅》今日发布终极预告。两分零七秒的画面里没有一句完整的对白，只有舱体的金属回响、呼吸声与一段反复出现的电台杂音。导演周砚在采访中表示，这部电影想讨论的并不是外星文明，而是人在绝对孤独中如何确认自己仍然存在。\n\n预告中最受关注的是“归途号”失联后的三十秒。导航员陆行独自穿过零重力的环形走廊，舷窗外那颗编号 X-19 的蓝色行星缓慢转过来，屏幕上的氧气读数从 12% 跳到 11%。制片方透露，这一段落全部采用实景搭建的舱体拍摄，演员在封闭空间内连续工作了十九天。\n\n影片的配乐同样克制，全片只有三首完整的曲子，其余都是环境声。声音指导称，他们录制了大量真实金属在低温下的形变声，再将其放慢数倍，用作太空的“底噪”。\n\n《星际孤旅》将于下月正式上映，片长 128 分钟。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20lone%20astronaut%20floating%20inside%20a%20dark%20spacecraft%20corridor%2C%20blue%20planet%20visible%20through%20a%20round%20window%2C%20deep%20navy%20tones%20with%20warm%20amber%20instrument%20lights%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=news-01&orientation=landscape",
  },
  {
    id: "n2",
    title: "悬疑剧《长夜将明》收官，双线叙事在第八集完成交汇",
    date: "2026年10月12日",
    category: "行业动态",
    summary:
      "该剧凭借克制的节奏与扎实的群像塑造收获口碑，收官当晚相关话题持续占据讨论榜前列。",
    content:
      "《长夜将明》本周正式收官。全剧 24 集，前半段几乎不解释任何动机，只呈现人物在走廊、值班室和雨夜里的沉默，直到第八集两条时间线交汇，观众才意识到前面所有的空白都是证词。\n\n编剧团队在幕后访谈中提到，剧本初稿曾把真相放在第三集，后来整体推倒重写。“我们不想让观众猜凶手，我们想让观众理解为什么所有人都不说话。”\n\n该剧的摄影同样被频繁讨论。全剧几乎没有自然光，值班室的顶灯、走廊尽头的应急灯和窗外的路灯构成了主要的三种光源，人物的脸常常只有一半被照亮。\n\n平台方表示，剧集完结后仍会保留完整的剧集目录与分集简介，方便观众回看线索。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20empty%20police%20station%20corridor%20at%20midnight%2C%20single%20warm%20ceiling%20lamp%2C%20rain%20streaks%20on%20windows%2C%20deep%20navy%20shadows%2C%20moody%20film%20look%2C%20no%20text&width=800&height=500&seq=news-02&orientation=landscape",
  },
  {
    id: "n3",
    title: "古装剧《春山书院》美术特辑：一座书院如何被搭出来",
    date: "2026年10月09日",
    category: "幕后花絮",
    summary:
      "剧组公开了书院主场景的搭建过程，从梁柱比例到窗棂纹样，均参考了多处现存古建的测绘资料。",
    content:
      "《春山书院》发布美术特辑，首次完整展示了主场景的搭建过程。整座书院占地约 2400 平方米，包含讲堂、藏书楼、后山碑廊与两进学生舍院，其中讲堂的梁柱比例参考了多份古建测绘资料。\n\n美术指导介绍，书院里最重要的道具是那张被反复使用的长案。“所有的辩论、罚站、偷偷传纸条都发生在这张桌子前，它必须足够长，长到两个人坐在两端时看起来真的很远。”\n\n特辑还展示了窗棂的纹样设计。为了区分不同身份的学生，舍院的窗棂采用了三种不同的格心图案，这些细节在正片中往往只出现一两秒。\n\n该剧全 36 集已完结，观众可在剧集详情页查看分集目录。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20traditional%20Chinese%20academy%20courtyard%20with%20wooden%20pillars%20and%20lattice%20windows%2C%20warm%20lantern%20light%20at%20dusk%2C%20deep%20navy%20shadows%2C%20elegant%20period%20drama%20look%2C%20no%20text&width=800&height=500&seq=news-03&orientation=landscape",
  },
  {
    id: "n4",
    title: "《迷雾追凶》定档：一场持续七个雾夜的追查",
    date: "2026年10月06日",
    category: "上映预告",
    summary:
      "影片公布定档海报与首支正片片段，潮湿的港口、停摆的怀表和层层嵌套的时间线成为讨论焦点。",
    content:
      "《迷雾追凶》正式定档。影片故事发生在港口，连续七个雾夜出现同一艘无人渔船，船上只留下一枚停摆在凌晨三点的旧怀表。\n\n首支正片片段全长 90 秒，全程没有一个正脸镜头，只有手电筒的光在雾里扫过集装箱编号。导演陈启峰表示，影片刻意放弃了常见的追车与爆破，把紧张感全部放在“看不清”这件事上。\n\n值得一提的是，片中所有雾景都是实拍，剧组在港口连续等待了二十多天，只为拍到能见度低于十五米的自然雾。\n\n影片片长 121 分钟，将于近期登陆院线。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20harbor%20pier%20covered%20in%20thick%20fog%20at%20night%2C%20single%20amber%20street%20lamp%20and%20dark%20container%20silhouettes%2C%20deep%20navy%20teal%20palette%2C%20mystery%20film%20mood%2C%20no%20text&width=800&height=500&seq=news-04&orientation=landscape",
  },
  {
    id: "n5",
    title: "生活流剧集《我们的小城》为何让人看得下去",
    date: "2026年10月03日",
    category: "专题报道",
    summary:
      "没有强冲突、没有反转，一部关于早餐店搬迁的剧集，靠一日三餐和细碎对话留住了观众。",
    content:
      "《我们的小城》播出后，最常被提到的一个词是“像”。像自己家楼下的早餐店，像母亲坚持不换的那口锅，像饭桌上突然安静下来的那三十秒。\n\n全剧 30 集，几乎没有激烈的冲突。最大的事件是店铺搬迁，而这件事被拆成了三十个早晨：贴通知、算账、跟老邻居解释、试新配方、把旧招牌擦干净。\n\n导演沈嘉言在采访中说，剧组要求所有演员在开拍前到真实的早餐店工作三天。“不是为了体验生活，是为了让手知道该怎么端碗。”\n\n这种克制也体现在镜头上。全剧大量使用固定机位，人物进出画框，锅里的蒸汽升起来又散掉。看完之后你未必记得剧情，但会记得那个味道。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20small%20town%20breakfast%20shop%20at%20dawn%2C%20steaming%20bamboo%20baskets%20and%20warm%20amber%20light%2C%20deep%20navy%20blue%20morning%20shadows%2C%20cozy%20realistic%20film%20look%2C%20no%20text&width=800&height=500&seq=news-05&orientation=landscape",
  },
  {
    id: "n6",
    title: "动画电影《山海图卷》发布水墨幕后短片",
    date: "2026年09月29日",
    category: "幕后花絮",
    summary:
      "短片展示了水墨与三维结合的制作流程，山峦的“呼吸感”来自逐帧调整的墨色扩散。",
    content:
      "《山海图卷》发布水墨幕后短片。影片最被称道的山峦“呼吸感”，实际上来自极为笨拙的手工流程：每一层山体的墨色扩散都要单独绘制，再与三维模型逐帧对齐。\n\n动画总监介绍，全片共有 47 座主要山体，每座山至少有五层墨色，最终呈现的镜头里，一座山在四秒内会经历约 96 次细微的明暗变化。\n\n短片中还有一个细节：画中异兽的名字不是写上去的，而是“长”出来的，墨迹从笔画末端往回蔓延，像伤口愈合。\n\n影片片长 104 分钟，目前仍在院线放映。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20layered%20Chinese%20ink%20painting%20mountains%20with%20drifting%20mist%2C%20deep%20navy%20night%20sky%20with%20warm%20amber%20glow%20on%20peaks%2C%20elegant%20oriental%20aesthetic%2C%20no%20text&width=800&height=500&seq=news-06&orientation=landscape",
  },
  {
    id: "n7",
    title: "《霓虹之下》用一间洗衣店装下整条街的秘密",
    date: "2026年09月25日",
    category: "专题报道",
    summary:
      "这部 20 集的港味悬疑剧把主要场景压缩在不足四十平方米的空间里，群像与信息密度成为最大看点。",
    content:
      "《霓虹之下》的全部主线几乎都发生在一间二十四小时洗衣店里。收银台、六台洗衣机、一条长凳，加上一本被反复翻看的记事簿，构成了整部剧的舞台。\n\n导演陈启峰说，选择洗衣店是因为它是城市里少数“所有人都必须停留”的地方。“你不能洗完衣服就走，你只能坐着等。”\n\n这种限制反而带来了极强的叙事效率。每一集都有新的陌生人推门进来，每个人的衣服上都带着不同的故事，而记事簿上的名字与日期，慢慢拼出了一桩未被报案的失踪。\n\n全剧 20 集，节奏紧凑，几乎没有废戏。剧集详情页已上线完整分集目录。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20small%2024-hour%20laundromat%20in%20Hong%20Kong%20at%20night%2C%20warm%20orange%20neon%20reflections%20on%20wet%20street%2C%20deep%20navy%20shadows%2C%20moody%20urban%20film%20look%2C%20no%20text&width=800&height=500&seq=news-07&orientation=landscape",
  },
  {
    id: "n8",
    title: "科幻剧《静默信号》确认续订，第二季将聚焦山谷之外",
    date: "2026年09月21日",
    category: "行业动态",
    summary:
      "第一季以极简场景和声音设计获得关注，制作方确认第二季将扩展世界观，但保留原有的静默气质。",
    content:
      "《静默信号》正式确认续订第二季。第一季共 10 集，讲述全球无线电静默后，一座山谷观测站收到重复脉冲信号的七天。\n\n制作方在公告中提到，第二季会把视角从山谷移向“山谷之外”，但会保留第一季最重要的部分：极少的台词、大量环境声，以及几乎不解释的结尾。\n\n第一季最受讨论的是第七集。整整四十分钟里，人物几乎没有说话，只有风、金属形变声和一段越来越慢的脉冲。有观众称这是“今年最安静的恐怖”。\n\n第二季预计明年进入拍摄，具体上线时间尚未公布。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20radio%20telescope%20dish%20in%20a%20silent%20dark%20valley%20at%20night%2C%20deep%20navy%20sky%2C%20single%20warm%20amber%20signal%20light%2C%20cold%20atmospheric%20sci-fi%20mood%2C%20no%20text&width=800&height=500&seq=news-08&orientation=landscape",
  },
];